import React from "react";
import { PointData } from "./data";
import "./scrollHoz.css";

const ResponsiveSection = () => {
  return (
    <div className="img3 vh-100">
      <h1 className="gradient-small text-center">Hardware Edge Nodes</h1>
      <div className="container">
        <div
          id="carouselExampleAutoplaying"
          className="carousel slide my-5"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {PointData?.map((data, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={data.id}
              >
                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                  <img
                    src={data.img}
                    className="d-block img-fluid mb-3"
                    alt="..."
                  />
                  <div className="section-lights rounded rounded-3 w-75 text-start">
                    <div className="d-flex align-items-start">
                      <img
                        src={data.icon}
                        height={50}
                        width={50}
                        alt=""
                        className="me-3 icon-img"
                      />
                      <div>
                        <h5 className="gradient-small">{data.title}</h5>
                        <p className="text-light-gold">{data.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveSection;
